import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Download the server-sealed signed PDF (and optional certificate JSON).
 * @returns {Promise<{ certificate: object, recordSha256: string, pdfSha256: string, filename: string }>}
 */
export async function downloadSealedSignedPdf(payload) {
  const functions = getFunctions();
  const getSealed = httpsCallable(functions, 'getSealedSignedDocument');
  const res = await getSealed(payload);
  const data = res.data || {};
  const url = data.downloadUrl;
  if (!url) {
    throw new Error('Sealed PDF is not available yet.');
  }
  const a = document.createElement('a');
  a.href = url;
  a.download = data.filename || 'signed.pdf';
  a.rel = 'noopener';
  a.click();
  return {
    certificate: data.certificate || null,
    recordSha256: data.recordSha256 || '',
    pdfSha256: data.pdfSha256 || '',
    filename: data.filename || 'signed.pdf',
  };
}

export function downloadCertificateJson(certificate, filenameBase) {
  if (!certificate) throw new Error('Certificate is not available.');
  const blob = new Blob([JSON.stringify(certificate, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const base = String(filenameBase || 'certificate-of-completion').replace(/[\\/:*?"<>|]+/g, '-');
  a.download = `${base}-certificate.json`;
  a.click();
  URL.revokeObjectURL(url);
}
